import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { useMessageContext } from '../context/MessageContext';
import './Navbar.css';

const Navbar: React.FC = () => {
  const { user, logout, isAuthenticated } = useAuth();
  const { unreadCount } = useMessageContext();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setMenuOpen(false);
    
    console.log('Logout gestartet');
    
    // Token und User sofort entfernen
    localStorage.removeItem('token');
    localStorage.removeItem('user');
    
    try {
      await logout();
    } catch (error) {
      console.error('Fehler beim Logout:', error);
    }
    
    // Seite neu laden, um sicherzustellen, dass alle Komponenten den neuen State haben
    console.log('Weiterleitung zu /login');
    window.location.href = '/login';
  };

  const closeMenu = () => setMenuOpen(false);

  return (
    <nav className="navbar">
      <div className="navbar-container">
        <Link to="/dashboard" className="navbar-logo" onClick={closeMenu}>
          🦆 Cruising Ducks
        </Link>
        <button
          type="button"
          className="navbar-toggle"
          aria-label="Menü öffnen"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((prev) => !prev)}
        >
          <span />
          <span />
          <span />
        </button>
        <div className="navbar-menu">
          <div className={`navbar-links ${menuOpen ? 'open' : ''}`}>
            {isAuthenticated && (
              <>
                <Link to="/dashboard" className="navbar-link" onClick={closeMenu}>
                  Dashboard
                </Link>
                <Link to="/log-duck" className="navbar-link" onClick={closeMenu}>
                  Ente loggen
                </Link>
                <Link to="/search" className="navbar-link" onClick={closeMenu}>
                  Suchen
                </Link>
                <Link to="/dev-chat" className="navbar-link" onClick={closeMenu}>
                  Dev-Chat
                </Link>
                <Link to="/messages" className="navbar-link" onClick={closeMenu}>
                  Nachrichten
                  {unreadCount > 0 && (
                    <span className="navbar-badge">{unreadCount > 99 ? '99+' : unreadCount}</span>
                  )}
                </Link>
                {user?.is_admin && (
                  <Link to="/admin" className="navbar-link" onClick={closeMenu}>
                    Admin
                  </Link>
                )}
                <Link to={`/profile/${user?.id}`} className="navbar-link" onClick={closeMenu}>
                  Profil
                </Link>
                <button type="button" onClick={handleLogout} className="navbar-button">
                  Abmelden
                </button>
              </>
            )}
            <Link to="/changelog" className="navbar-link" onClick={closeMenu}>
              Was ist neu?
            </Link>
          </div>
          {menuOpen && <div className="navbar-overlay" onClick={closeMenu} />}
        </div>
      </div>
    </nav>
  );
};

export default Navbar;

